<template>
  <div>
    <h4 class="font-weight-bold pb-1 indigo--text">Gestión</h4>
    <h5 class="font-weight-light">Gestión de trabajadores</h5>
    <v-form ref="formulario" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" lg="12">
          <v-card class="elevation-3 mt-5">
            <v-row>
              <v-col cols="12" lg="12">
                <v-card-title class="font-weight-light text-overline">
                  Antecedentes del Trabajador
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="faena_minera"
                          v-model="datosFormulario.faena_minera"
                          outlined
                          item-value="tipo"
                          label="Faena Minera"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="tipo_trabajador"
                          v-model="datosFormulario.tipo_trabajador"
                          outlined
                          item-value="tipo"
                          label="Tipo Trabajador"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Ceco"
                          v-model="datosFormulario.ceco"
                          outlined
                          hide-details
                          :rules="basic_validation_rules_input"
                          required
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Nombre completo"
                          v-model="datosFormulario.nombre"
                          outlined
                          hide-details
                          :rules="basic_validation_rules_input"
                          required
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Rut"
                          v-model="datosFormulario.rut"
                          outlined
                          hide-details
                          @input="checkRut"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="cargo"
                          v-model="datosFormulario.cargo"
                          outlined
                          item-value="tipo"
                          label="Cargo"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="tipo_cargo"
                          v-model="datosFormulario.tipo_cargo"
                          outlined
                          item-value="tipo"
                          label="Tipo Cargo"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="estado_general"
                          v-model="datosFormulario.estado_general"
                          outlined
                          item-value="tipo"
                          label="Estado General"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="estatus_candidato"
                          v-model="datosFormulario.estatus_candidato"
                          outlined
                          item-value="tipo"
                          label="Estatus Candidato"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha de nacimiento"
                          v-model="datosFormulario.fecha_nacimiento"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Edad"
                          v-model="datosFormulario.edad"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Nacionalidad"
                          v-model="datosFormulario.nacionalidad"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Estado civil"
                          v-model="datosFormulario.estado_civil"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Email"
                          v-model="datosFormulario.email"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Telefono"
                          v-model="datosFormulario.telefono"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Dirección"
                          v-model="datosFormulario.direccion"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Comuna"
                          v-model="datosFormulario.comuna"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Ciudad"
                          v-model="datosFormulario.ciudad"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Calzado"
                          v-model="datosFormulario.calzado"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Polera"
                          v-model="datosFormulario.polera"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Pantalón"
                          v-model="datosFormulario.pantalon"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="En caso de emergencia avisar a"
                          v-model="datosFormulario.en_caso_de_emergencia_nombre"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Parentesco"
                          v-model="datosFormulario.parentesco"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Teléfono 2"
                          v-model="datosFormulario.telefono2"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                            :items="estudios"
                            v-model="datosFormulario.nivel_estudios"
                            outlined
                            item-value="tipo"
                            label="Nivel de estudios"
                            hide-details
                            :rules="basic_validation_rules_select"
                            required
                          ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Nombre establecimiento"
                          v-model="datosFormulario.nombre_establecimiento"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Título"
                          v-model="datosFormulario.titulo"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        
                        <v-select
                          :items="selector_simple_familiar"
                          v-model="datosFormulario.tiene_familia_trabajando_en_compass"
                          outlined
                          item-value="tipo"
                          label="Tiene familiar trabajando en compass?"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="(En caso positivo) Nombre familiar"
                          v-model="datosFormulario.nombre_familiar"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="selector_simple_ha_trabajado_compass"
                          v-model="datosFormulario.ha_trabajado_antes_en_compass"
                          outlined
                          item-value="tipo"
                          label="Ha trabajado antes en compass?"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Validación compass"
                          v-model="datosFormulario.validacion_compass"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Nombre empleador anterior"
                          v-model="datosFormulario.nombre_empleador_anterior"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Teléfono empresa"
                          v-model="datosFormulario.telefono_empresa"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Periodo que trabajo ahí"
                          v-model="datosFormulario.periodo_que_trabajo_ahi"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Cargo que desempeñó"
                          v-model="datosFormulario.cargo_desempeno_ahi"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Motivo témino de contrato"
                          v-model="datosFormulario.motivo_termino_contrato"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-select
                          :items="selector_simple"
                          v-model="datosFormulario.experiencia_mineria"
                          outlined
                          item-value="tipo"
                          label="Experiencia en mineria"
                          hide-details
                          :rules="basic_validation_rules_select"
                          required
                        ></v-select>
                      </v-col>
                     
                      <v-col cols="12" lg="6">
                        <v-select
                            :items="anios_experiencia"
                            v-model="datosFormulario.anios_de_experiencia"
                            outlined
                            item-value="tipo"
                            label="Años de experiencia"
                            hide-details
                            :rules="basic_validation_rules_select"
                            required
                          ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="En que minera trabajó"
                          v-model="datosFormulario.minera_que_trabajo_antes"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Tiene hijos?"
                          v-model="datosFormulario.tiene_hijos"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Cuantos hijos"
                          v-model="datosFormulario.cantidad_hijos"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Edad de sus hijos"
                          v-model="datosFormulario.edades_hijos"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Nombre Banco"
                          v-model="datosFormulario.nombre_banco"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Tipo cuenta bancaria"
                          v-model="datosFormulario.tipo_cuenta"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Número de cuenta bancaria"
                          v-model="datosFormulario.nro_cuenta"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha examen"
                          v-model="datosFormulario.fecha_examen"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Laboratorio"
                          v-model="datosFormulario.laboratorio"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Número de reserva"
                          v-model="datosFormulario.nro_reserva"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Tipo de examen"
                          v-model="datosFormulario.tipo_examen"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Resultado ELA"
                          v-model="datosFormulario.resultado_ela"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Resultado A&D"
                          v-model="datosFormulario.resultado_ad"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Resultado manipulador"
                          v-model="datosFormulario.resultado_manipulador"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Resultado psicosensometrico"
                          v-model="datosFormulario.resultado_psicosensometrico"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Certificado de competencias"
                          v-model="datosFormulario.certificado_competencias"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha INH"
                          v-model="datosFormulario.fecha_inh"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Resultado INH"
                          v-model="datosFormulario.resultado_inh"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="C. de antecedentes"
                          v-model="datosFormulario.c_antecedentes"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="AFP a la cual está afiliado"
                          v-model="datosFormulario.afiliacion_afp"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Cotizaciones"
                          v-model="datosFormulario.cotizaciones"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Afiliación de salud (Indicar cual)"
                          v-model="datosFormulario.afiliacion_salud"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Cédula de identidad"
                          v-model="datosFormulario.cedula_identidad"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="C.V"
                          v-model="datosFormulario.cv"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Finiquito"
                          v-model="datosFormulario.finiquito"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Certificado de residencia"
                          v-model="datosFormulario.certificado_residencia"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Certificado de estudios"
                          v-model="datosFormulario.certificado_estudios"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Validación C. de estudios"
                          v-model="datosFormulario.validacion_c_estudios"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Foto fondo blanco"
                          v-model="datosFormulario.foto_fondo_blanco"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Ficha de ingreso"
                          v-model="datosFormulario.ficha_ingreso"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha solicitud de contrato"
                          v-model="datosFormulario.fecha_solicitud_contrato"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha firma contrato"
                          v-model="datosFormulario.fecha_firma_contrato"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Fecha solicitud de acreditación"
                          v-model="datosFormulario.fecha_solicitud_acreditacion"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-text-field
                          label="Observaciones"
                          v-model="datosFormulario.observaciones"
                          outlined
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <v-switch
                            v-model="datosFormulario.activo"
                            label="Estado"
                            color="primary"
                            hide-details
                            class="ml-5"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-col>
              
            </v-row>
            <v-divider class="m-0"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                color="indigo lighten-5"
                class="mb-2 indigo lighten-5 primary--text"
                v-if="idDato"
                @click="editData"
                right
                >Editar</v-btn
              >
              <v-btn
                :loading="loading"
                color="indigo lighten-5"
                class="mb-2 indigo lighten-5 primary--text"
                v-if="!idDato"
                @click="saveData"
                right
                >Grabar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
class datosReporte {
  constructor(datos = {}) {
    this.nombre = datos.nombre;
    this.rut = datos.rut;
    this.cargo = datos.cargo;
    this.activo = datos.activo;
    this.direccion = datos.direccion;
    this.responsable = datos.responsable;

    this.faena_minera = datos.faena_minera;
    this.tipo_cargo = datos.tipo_cargo;
    this.estado_general = datos.estado_general;
    this.estatus_general = datos.estatus_general;
    this.estatus_candidato = datos.estatus_candidato;
    this.fecha_nacimiento = datos.fecha_nacimiento;
    this.edad = datos.edad;
    this.nacionalidad = datos.nacionalidad;
    this.estado_civil = datos.estado_civil;
    this.email = datos.email;
    this.telefono = datos.telefono;
    this.comuna = datos.comuna;
    this.ciudad = datos.ciudad;
    this.calzado = datos.calzado;
    this.polera = datos.polera;
    this.pantalon = datos.pantalon;
    this.en_caso_de_emergencia_nombre = datos.en_caso_de_emergencia_nombre;
    this.parentesco = datos.parentesco;
    this.telefono2 = datos.telefono2;
    this.nivel_estudios = datos.nivel_estudios;
    this.nombre_establecimiento = datos.nombre_establecimiento;
    this.titulo = datos.titulo;
    this.tiene_familia_trabajando_en_compass = datos.tiene_familia_trabajando_en_compass;
    this.nombre_familiar = datos.nombre_familiar;
    this.ha_trabajado_antes_en_compass = datos.ha_trabajado_antes_en_compass;
    this.validacion_compass = datos.validacion_compass;
    this.nombre_empleador_anterior = datos.nombre_empleador_anterior;
    this.telefono_empresa = datos.telefono_empresa;
    this.periodo_que_trabajo_ahi = datos.periodo_que_trabajo_ahi;
    this.cargo_desempeno_ahi = datos.cargo_desempeno_ahi;
    this.motivo_termino_contrato = datos.motivo_termino_contrato;
    this.experiencia_mineria = datos.experiencia_mineria;
    this.anios_de_experiencia = datos.anios_de_experiencia;
    this.minera_que_trabajo_antes = datos.minera_que_trabajo_antes;
    this.tiene_hijos = datos.tiene_hijos;
    this.cantidad_hijos = datos.cantidad_hijos;
    this.edades_hijos = datos.edades_hijos;
    this.nombre_banco = datos.nombre_banco;
    this.tipo_cuenta = datos.tipo_cuenta;
    this.nro_cuenta = datos.nro_cuenta;
    this.fecha_examen = datos.fecha_examen;
    this.laboratorio = datos.laboratorio;
    this.nro_reserva = datos.nro_reserva;
    this.tipo_examen = datos.tipo_examen;
    this.resultado_ela = datos.resultado_ela;
    this.resultado_ad = datos.resultado_ad;
    this.resultado_manipulador = datos.resultado_manipulador;
    this.resultado_psicosensometrico = datos.resultado_psicosensometrico;
    this.certificado_competencias = datos.certificado_competencias;
    this.fecha_inh = datos.fecha_inh;
    this.resultado_inh = datos.resultado_inh;
    this.c_antecedentes = datos.c_antecedentes;
    this.afiliacion_afp = datos.afiliacion_afp;
    this.cotizaciones = datos.cotizaciones;
    this.afiliacion_salud = datos.afiliacion_salud;
    this.cedula_identidad = datos.cedula_identidad;
    this.cv = datos.cv;
    this.finiquito = datos.finiquito;
    this.certificado_residencia = datos.certificado_residencia;
    this.certificado_estudios = datos.certificado_estudios;
    this.validacion_c_estudios = datos.validacion_c_estudios;
    this.foto_fondo_blanco = datos.foto_fondo_blanco;
    this.ficha_ingreso = datos.ficha_ingreso;
    this.fecha_solicitud_contrato = datos.fecha_solicitud_contrato;
    this.fecha_firma_contrato = datos.fecha_firma_contrato;
    this.fecha_solicitud_acreditacion = datos.fecha_solicitud_acreditacion;
    this.observaciones = datos.observaciones;
    this.tipo_trabajador = datos.tipo_trabajador;
    this.ceco = datos.ceco;
  }
}

export default {
  data() {
    return {
      valid: true,
      basic_validation_rules_input: [
        (v) => !!v || "Campo obligatorio",
        (v) => (v && v.length <= 50) || "Campo requerido",
      ],
      basic_validation_rules_email: [
        (v) => !!v || "E-mail es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "Debe ingresar un Email válido",
      ],
      basic_validation_rules_select: [(v) => !!v || "Campo obligatorio"],
      basic_validation_rules_rut: [
        (v) => !!v || "Campo obligatorio",
        (v) => this.validaRut(v) || "Rut Incorrecto",
      ],

      loading: false,
      idDato: null,
      ex11: true,

      tipo: [
        {
          tipo: "ADMIN",
          text: "Admin",
        },
        {
          tipo: "USUARIO",
          text: "Usuario",
        },
      ],
      cargo: [
      {tipo: "ADMINISTRADOR DE CONTRATO", text: "ADMINISTRADOR DE CONTRATO",},
      {tipo: "ADMINISTRATIVO", text: "ADMINISTRATIVO",},
      {tipo: "ADMINISTRATIVO GESTION DE RRHH Y HSEC", text: "ADMINISTRATIVO GESTION DE RRHH Y HSEC",},
      {tipo: "ANALISTA DE CONTROL GESTION", text: "ANALISTA DE CONTROL GESTION",},
      {tipo: "ANALISTA DE RECURSOS HUMANOS", text: "ANALISTA DE RECURSOS HUMANOS",},
      {tipo: "ASESOR DE CALIDAD", text: "ASESOR DE CALIDAD",},
      {tipo: "ASESOR DE HSEQ ", text: "ASESOR DE HSEQ ",},
      {tipo: "ASISTENTE ADMINISTRATIVO", text: "ASISTENTE ADMINISTRATIVO",},
      {tipo: "ASISTENTE DE CALIDAD", text: "ASISTENTE DE CALIDAD",},
      {tipo: "ASISTENTE DE GESTION", text: "ASISTENTE DE GESTION",},
      {tipo: "ASISTENTE DE PREVENCION DE RIESGOS", text: "ASISTENTE DE PREVENCION DE RIESGOS",},
      {tipo: "ASISTENTE PLANIFICACION", text: "ASISTENTE PLANIFICACION",},
      {tipo: "ASPIRANTE A MAESTRO", text: "ASPIRANTE A MAESTRO",},
      {tipo: "ASPIRANTE A PANADERO", text: "ASPIRANTE A PANADERO",},
      {tipo: "AUDITOR INTERNO", text: "AUDITOR INTERNO",},
      {tipo: "AUXILIAR DE ASEO", text: "AUXILIAR DE ASEO",},
      {tipo: "AUXILIAR DE BODEGA", text: "AUXILIAR DE BODEGA",},
      {tipo: "AUXILIAR DE MANTENCIÓN", text: "AUXILIAR DE MANTENCIÓN",},
      {tipo: "AYUDANTE DE COCINA", text: "AYUDANTE DE COCINA",},
      {tipo: "AYUDANTE DE DISTRIBUCION", text: "AYUDANTE DE DISTRIBUCION",},
      {tipo: "AYUDANTE DE MANTENCIÓN", text: "AYUDANTE DE MANTENCIÓN",},
      {tipo: "AYUDANTE DE PANADERO", text: "AYUDANTE DE PANADERO",},
      {tipo: "BODEGUERO", text: "BODEGUERO",},
      {tipo: "CAJERO", text: "CAJERO",},
      {tipo: "CAPATAZ DE MANTENCION", text: "CAPATAZ DE MANTENCION",},
      {tipo: "CHEF DE COCINA", text: "CHEF DE COCINA",},
      {tipo: "CHEF DE PRODUCCION", text: "CHEF DE PRODUCCION",},
      {tipo: "CHOFER", text: "CHOFER",},
      {tipo: "CONTROL VENTAS", text: "CONTROL VENTAS",},
      {tipo: "CONTROLADOR DE DOCUMENTOS", text: "CONTROLADOR DE DOCUMENTOS",},
      {tipo: "COORDINADOR DE CALIDAD", text: "COORDINADOR DE CALIDAD",},
      {tipo: "COORDINADOR DE ENTRENAMIENTO Y COMUNICACIONES", text: "COORDINADOR DE ENTRENAMIENTO Y COMUNICACIONES",},
      {tipo: "COORDINADOR DE GERENCIA", text: "COORDINADOR DE GERENCIA",},
      {tipo: "COORDINADOR DE PERSONAS ", text: "COORDINADOR DE PERSONAS ",},
      {tipo: "DIGITADOR ", text: "DIGITADOR ",},
      {tipo: "ELECTRICO", text: "ELECTRICO",},
      {tipo: "ELECTROMECANICO", text: "ELECTROMECANICO",},
      {tipo: "ENCARGADA DE RECURSOS HUMANOS", text: "ENCARGADA DE RECURSOS HUMANOS",},
      {tipo: "ENCARGADO DE BODEGA", text: "ENCARGADO DE BODEGA",},
      {tipo: "ENCARGADO DE COBRANZA", text: "ENCARGADO DE COBRANZA",},
      {tipo: "ENCARGADO DE COMPRAS", text: "ENCARGADO DE COMPRAS",},
      {tipo: "ENCARGADO DE KIOSCO", text: "ENCARGADO DE KIOSCO",},
      {tipo: "ENCARGADO DE RECREACION", text: "ENCARGADO DE RECREACION",},
      {tipo: "ENCARGADO EVENTO", text: "ENCARGADO EVENTO",},
      {tipo: "GARZON", text: "GARZON",},
      {tipo: "GASFITER", text: "GASFITER",},
      {tipo: "JARDINERO", text: "JARDINERO",},
      {tipo: "JARDINERO AUXILIAR", text: "JARDINERO AUXILIAR",},
      {tipo: "JEFE CONTROL DE GESTION", text: "JEFE CONTROL DE GESTION",},
      {tipo: "JEFE DE ASEO Y LAVANDERIA", text: "JEFE DE ASEO Y LAVANDERIA",},
      {tipo: "JEFE DE BODEGA", text: "JEFE DE BODEGA",},
      {tipo: "JEFE DE KIOSCO", text: "JEFE DE KIOSCO",},
      {tipo: "JEFE DE LOGISTICA Y DESPACHO", text: "JEFE DE LOGISTICA Y DESPACHO",},
      {tipo: "JEFE DE OPERACIONES", text: "JEFE DE OPERACIONES",},
      {tipo: "JEFE DE RECURSOS HUMANOS", text: "JEFE DE RECURSOS HUMANOS",},
      {tipo: "JEFE DE RELACIONES LABORALES", text: "JEFE DE RELACIONES LABORALES",},
      {tipo: "JEFE DE SEGURIDAD Y MEDIO AMBIENTE", text: "JEFE DE SEGURIDAD Y MEDIO AMBIENTE",},
      {tipo: "JEFE DE SERVICIOS", text: "JEFE DE SERVICIOS",},
      {tipo: "JEFE DE TURNO", text: "JEFE DE TURNO",},
      {tipo: "JEFE DEPARTAMENTO DE CALIDAD", text: "JEFE DEPARTAMENTO DE CALIDAD",},
      {tipo: "JEFE RECEPCION HOTELERA", text: "JEFE RECEPCION HOTELERA",},
      {tipo: "LIDER DE ASEO", text: "LIDER DE ASEO",},
      {tipo: "LIDER DE EQUIPO", text: "LIDER DE EQUIPO",},
      {tipo: "LIDER DE MANTENCION", text: "LIDER DE MANTENCION",},
      {tipo: "LIDER DE SERVICIOS", text: "LIDER DE SERVICIOS",},
      {tipo: "MAESTRO COCINA", text: "MAESTRO COCINA",},
      {tipo: "MAESTRO LIDER", text: "MAESTRO LIDER",},
      {tipo: "MAESTRO MANTENCION", text: "MAESTRO MANTENCION",},
      {tipo: "MAESTRO MANTENCION PLANTA", text: "MAESTRO MANTENCION PLANTA",},
      {tipo: "MAESTRO MANTENCION PRIMERA", text: "MAESTRO MANTENCION PRIMERA",},
      {tipo: "MAESTRO MANTENCION SEGUNDA", text: "MAESTRO MANTENCION SEGUNDA",},
      {tipo: "MAESTRO PANADERO", text: "MAESTRO PANADERO",},
      {tipo: "MAESTRO REPOSTERO", text: "MAESTRO REPOSTERO",},
      {tipo: "MONITOR DEPORTIVO", text: "MONITOR DEPORTIVO",},
      {tipo: "MUCAMA", text: "MUCAMA",},
      {tipo: "NUTRICIONISTA", text: "NUTRICIONISTA",},
      {tipo: "PLANIFICADOR", text: "PLANIFICADOR",},
      {tipo: "PREVENCIONISTA DE RIESGOS", text: "PREVENCIONISTA DE RIESGOS",},
      {tipo: "PROFESOR DE EDUCACION FISICA", text: "PROFESOR DE EDUCACION FISICA",},
      {tipo: "PSICOLOGO", text: "PSICOLOGO",},
      {tipo: "RECEPCIONISTA ADMINISTRACION HOTELERA", text: "RECEPCIONISTA ADMINISTRACION HOTELERA",},
      {tipo: "SECRETARIA", text: "SECRETARIA",},
      {tipo: "SUB GERENTE", text: "SUB GERENTE",},
      {tipo: "SUB GERENTE RECURSOS HUMANOS", text: "SUB GERENTE RECURSOS HUMANOS",},
      {tipo: "SUB GERENTE RELACIONES LABORALES", text: "SUB GERENTE RELACIONES LABORALES",},
      {tipo: "SUPERVISOR ALIMENTACION", text: "SUPERVISOR ALIMENTACION",},
      {tipo: "SUPERVISOR ASEO", text: "SUPERVISOR ASEO",},
      {tipo: "SUPERVISOR DE BODEGA", text: "SUPERVISOR DE BODEGA",},
      {tipo: "SUPERVISOR DE CASINO", text: "SUPERVISOR DE CASINO",},
      {tipo: "SUPERVISOR DE KIOSKO", text: "SUPERVISOR DE KIOSKO",},
      {tipo: "SUPERVISOR GENERAL", text: "SUPERVISOR GENERAL",},
      {tipo: "SUPERVISOR MANTENCION", text: "SUPERVISOR MANTENCION",},
      {tipo: "SUPERVISOR SENIOR", text: "SUPERVISOR SENIOR",},
      {tipo: "TECNICO CARPINTERIA", text: "TECNICO CARPINTERIA",},
      {tipo: "TECNICO ELECTRICO", text: "TECNICO ELECTRICO",},
      {tipo: "TECNICO EN REFRIGERACION Y/O CLIMATIZACION", text: "TECNICO EN REFRIGERACION Y/O CLIMATIZACION",},
      {tipo: "TECNICO ESPECIALISTA", text: "TECNICO ESPECIALISTA",},
      {tipo: "TECNICO FRIGORISTA", text: "TECNICO FRIGORISTA",},
      {tipo: "TECNICO MANTENCION", text: "TECNICO MANTENCION",},
      {tipo: "VENDEDOR", text: "VENDEDOR",},
      {tipo: "GERENTE DE CONTRATO", text: "GERENTE DE CONTRATO",},
      {tipo: "DIRECTOR DE PROYECTO", text: "DIRECTOR DE PROYECTO",},
      {tipo: "CHEF EJECUTIVO", text: "CHEF EJECUTIVO",},
      {tipo: "AUXILIAR DE SERVICIO", text: "AUXILIAR DE SERVICIO",},
      ],
      tipo_cargo: [
        {
          tipo: "STAFF",
          text: "STAFF",
        },
        {
          tipo: "OPERATIVO",
          text: "OPERATIVO",
        },
        {
          tipo: "CARGO CLAVE",
          text: "CARGO CLAVE",
        },
      ],
      tipo_trabajador: [
        {
          tipo: "NUEVO",
          text: "NUEVO",
        },
        {
          tipo: "TRASLADO",
          text: "TRASLADO",
        }
      ],
      estudios: [
        {
          tipo: "Básico incompleto",
          text: "Básico incompleto",
        },
        {
          tipo: "Básico completo",
          text: "Básico completo",
        },
        {
          tipo: "Medio incompleto",
          text: "Medio incompleto",
        },
        {
          tipo: "Medio completo",
          text: "Medio completo",
        },
        {
          tipo: "Superior incompleto",
          text: "Superior incompleto",
        },
        {
          tipo: "Superior completo",
          text: "Superior completo",
        },
        
      ],
      estado_general: [
        {
          tipo: "VALIDACION DOCUMENTAL",
          text: "VALIDACION DOCUMENTAL",
        },
        {
          tipo: "VALIDACION HOTELERA",
          text: "VALIDACION HOTELERA",
        },
        {
          tipo: "EXAMENES MEDICOS",
          text: "EXAMENES MEDICOS",
        },
        {
          tipo: "INDUCCION HOMBRE NUEVO",
          text: "INDUCCION HOMBRE NUEVO",
        },
        {
          tipo: "OK PARA CONTRATO",
          text: "OK PARA CONTRATO",
        }
      ],
      estatus_candidato: [
        {
          tipo: "EN PROCESO",
          text: "EN PROCESO",
        },
        {
          tipo: "SOLICITUD DE CONTRATO",
          text: "SOLICITUD DE CONTRATO",
        },
        {
          tipo: "EN FIRMA CONTRATO",
          text: "EN FIRMA CONTRATO",
        },
        {
          tipo: "CONTRATO FIRMADO",
          text: "CONTRATO FIRMADO",
        },
        {
          tipo: "ACREDITACION",
          text: "ACREDITACION",
        },
        {
          tipo: "BAJA DEL PROCESO",
          text: "BAJA DEL PROCESO",
        },
        {
          tipo: "ACREDITADO",
          text: "ACREDITADO", 
        },
      ],
      anios_experiencia: [
        {
          tipo: "1-5",
          text: "1-5 años",
        },
        {
          tipo: "6-10",
          text: "6-10 años",
        },
        {
          tipo: "11 o más",
          text: "11 o más",
        },
      ],
      faena_minera: [
        {
          tipo: "COLLAHUASI",
          text: "COLLAHUASI",
        },
        {
          tipo: "ZALDIVAR",
          text: "ZALDIVAR",
        },
        {
          tipo: "CENTINELA",
          text: "CENTINELA",
        },
        {
          tipo: "QUEBRADA BLANCA",
          text: "QUEBRADA BLANCA",
        },
        {
          tipo: "CONCENTRADORA",
          text: "CONCENTRADORA",
        },
        {
          tipo: "OVEJERA",
          text: "OVEJERA",
        },
        {
          tipo: "PROYECTO",
          text: "PROYECTO",
        },
      ],
      selector_simple: [
        {
          tipo: "si",
          text: "si",
        },
        {
          tipo: "no",
          text: "no",
        },
      ],
      selector_simple_familiar: [
        {
          tipo: "si",
          text: "si",
        },
        {
          tipo: "no",
          text: "no",
        },
      ],
      selector_simple_ha_trabajado_compass: [
        {
          tipo: "si",
          text: "si",
        },
        {
          tipo: "no",
          text: "no",
        },
      ],

      datosFormulario: new datosReporte(new datosReporte()),

      seleccionados: [],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      menu3: false,
      noresult: "No existen resultados",
      search: "",
      sortBy: "ceco",
      sortDesc: false,
      headers: [
        {
          text: "Nombre Contacto",
          align: "start",
          value: "nombre",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        {
          text: "Teléfono",
          align: "start",
          value: "telefono",
        },
        {
          text: "Estado",
          align: "start",
          value: "activo",
        },
        {
          text: "Accion",
          value: "accion",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        nombre: "",
        email: "",
        telefono: "",
        activo: true,
      },
      dialog: false,
      dialogDelete: false,
    };
  },
  methods: {
    validate() { 
      this.$refs.formulario.validate();
    },
    validaRut: function (rutCompleto) {
      //rutCompleto = rutCompleto.replace("‐", "-");
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";

      return this.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
    lg(tipo) {
      if (tipo == 1) {
        return this.usuarioDB.data.role == "ADMIN" ? 6 : 12;
      } else {
        return this.usuarioDB.data.role == "ADMIN" ? 12 : 6;
      }
    },
    checkRut() {
      //console.log('llego');
    // Despejar Puntos
    var valor = this.datosFormulario.rut.replace('.','');
    var cuerpo = '';
    var dv = '';
    var value = '';

    // Despejar Guión
    valor = valor.replace('-','');
    
    // Aislar Cuerpo y Dígito Verificador
    cuerpo = valor.slice(0,-1);
    dv = valor.slice(-1).toUpperCase();
    
    // Formatear RUN
    this.datosFormulario.rut = cuerpo + '-'+ dv
    
    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    //if(cuerpo.length < 7) { rut.setCustomValidity("RUT Incompleto"); return false;}
    
    // Calcular Dígito Verificador
    var suma = 0;
    var multiplo = 2;
    var i = 1;
    
    // Para cada dígito del Cuerpo
    for(i=1;i<=cuerpo.length;i++) {
    
        // Obtener su Producto con el Múltiplo Correspondiente
        var index = multiplo * valor.charAt(cuerpo.length - i);
        
        // Sumar al Contador General
        suma = suma + index;
        
        // Consolidar Múltiplo dentro del rango [2,7]
        if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
  
    }
    
    // Calcular Dígito Verificador en base al Módulo 11
    var dvEsperado = 11 - (suma % 11);
    
    // Casos Especiales (0 y K)
    dv = (dv == 'K')?10:dv;
    dv = (dv == 0)?11:dv;
    
    // Validar que el Cuerpo coincide con su Dígito Verificador
    //if(dvEsperado != dv) { rut.setCustomValidity("RUT Inválido"); return false; }
    
    // Si todo sale bien, eliminar errores (decretar que es válido)
    //this.datosFormulario.rut.setCustomValidity('');
  },

    getData() {
      let config = {
        headers: {
          token: this.token,
        },
      };
      if (this.idDato) {
        axios.get("/trabajadores/trabajador/" + this.idDato, config).then((response) => {
          console.log(response);
          this.datosFormulario = new datosReporte(response.data);
        });
      } else {
      }
    },

    async editData() {
      this.loading = true;

      if (this.$refs.formulario.validate()) {
        let config = {
          headers: {
            token: this.token,
          },
        };

        await axios
          .put("/trabajadores/trabajador/" + this.idDato, this.datosFormulario, config)
          .then((response) => {
            this.$router.push({
              name: "trabajadores",
            });
            this.$toast.success(
              "Grabado con exito!",
              "",
              this.notificationSystem.options.error
            );
          })
          .catch((e) => {
            this.loading = false;
            this.$toast.error(
              "Ocurrio un error de sistema, vuelva a intentarlo",
              "Error",
              this.notificationSystem.options.error
            );
          });
      } else {
        this.loading = false;
        this.$toast.error(
          "Los campos en rojo son obligatorios, rellene y vuelva a intentarlo",
          "Error",
          this.notificationSystem.options.error
        );
      }
    },

    async saveData() {
      this.loading = true;

      this.datosFormulario.responsable = this.usuarioDB.data.nombre;

      if (this.$refs.formulario.validate()) {
        let config = {
          headers: {
            token: this.token,
          },
        };

        //console.log(this.datosFormulario);
        await axios
          .post("/trabajadores/trabajador/", this.datosFormulario, config)
          .then((response) => {
            setTimeout(() => (this.loading = false), 3000);
            this.$router.push({
              name: "trabajadores",
            });
            this.$toast.success(
              "Grabado con exito!",
              "",
              this.notificationSystem.options.error
            );
          })
          .catch((e) => {
            this.loading = false;
            this.$toast.error(
              "Ocurrio un error de sistema, vuelva a intentarlo",
              "Error",
              this.notificationSystem.options.error
            );
          });
      } else {
        this.loading = false;
        this.$toast.error(
          "Los campos en rojo son obligatorios, rellene y vuelva a intentarlo",
          "Error",
          this.notificationSystem.options.error
        );
      }
    },
    getEstados(estado) {
      if (estado == true) return "green";
      else if (estado == false) return "red";
      else return "grey";
    },

    getEstadosTexto(estado) {
      if (estado == true) return "Activo";
      else if (estado == false) return "Inactivo";
      else return "N/A";
    },
    //Contactos
    editItem(item) {
      this.editedIndex = this.datosFormulario.contactos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.datosFormulario.contactos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.datosFormulario.contactos.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        //Object.assign(this.desserts[this.editedIndex], this.editedItem);

        Object.assign(this.datosFormulario.contactos[this.editedIndex], this.editedItem);
      } else {
        this.datosFormulario.contactos.push(this.editedItem);
      }
      this.close();
    },
  },
  created() {
    if (this.$route.params.id) {
      this.idDato = this.$route.params.id;
    } else {
      this.datosFormulario.contactos = [];
    }

    //console.log(this.usuarioDB.data.nombre);

    this.getData();
  },
  mounted() {},
  computed: {
    ...mapState(["token", "usuarioDB", "itemsMenu", "notificationSystem"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Contacto" : "Editar Contacto";
    },
  },
  watch: {
    seleccionados: function (val) {
      this.datosFormulario.mods = [];
      for (let nodos of val) {
        this.datosFormulario.mods.push(nodos.id);
      }
    },
  },
};
</script>
<style>
.v-label--active {
  color: #1c67fd !important;
  font-weight: bold;
}
th span {
  color: "#FF0000" !important;
  border: 0px solid #7181b8;
  border-radius: 44px;
  padding: 5px;
  background: #e8eaf6;
}
#cardborde {
  border-top: 5px solid #e8eaf6 !important;
}
</style>
